import { createUseStyles } from 'react-jss';

const styles = {
  tableBody: {
    margin: {
      top: '2.4rem',
    },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
